export default __webpack_public_path__ + "static/media/team-member-04.ddd98e3d.jpeg";